export function getFormInstanceValues(formData: FormData) {
  let object: any = {};

  formData.forEach((value, key) => {
    // Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value;
      return;
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]];
    }
    object[key].push(value);
  });

  return object;
}

export function getFormValues(form: any) {
  if (!form) {
    throw Error('Form not provided !');
  }

  try {
    const formData = new FormData(form);

    return getFormInstanceValues(formData);
  } catch (err: any) {
    console.error(err);
    throw Error(err);
  }
};